module.exports = __webpack_public_path__ + "img/io.1ad24c62.png";